import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Services } from './servicios.service';
import { Observable } from 'rxjs';
import { Login } from './models/login-model';

@Injectable()
export class InterceptorService implements HttpInterceptor {

	constructor(public servicios: Services) {}
	
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		request = request.clone({
			setHeaders: {
				Authorization: `Bearer ${this.servicios.getBearerToken()}`
			}
		});
		return next.handle(request);
	}
}